export default __webpack_public_path__ + "static/media/map_marker.aa1fdc3d.png";